import React from 'react';
import { formatColumnName } from './dataProcessing';

const SortingControls = ({ sortColumn, setSortColumn, sortOrder, setSortOrder, columns, schema }) => {
  const getColumnLabel = (columnName) => {
    const field = schema?.fields?.find(f => f.name === columnName);
    return field ? formatColumnName(field.name) : columnName;
  };

  return (
    <div className="flex items-center space-x-2 sm:space-x-4">
      <div className="flex flex-col">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          <span className="sm:hidden">Sort</span>
          <span className="hidden sm:inline">Sort By</span>
        </label>
        <select 
          value={sortColumn} 
          onChange={(e) => setSortColumn(e.target.value)}
          className="w-full text-xs sm:text-sm py-1 px-1 sm:p-2 border rounded bg-white truncate"
          style={{ 
            minWidth: '80px',
            maxWidth: '150px'  // Fixed width limit
          }}
          title={sortColumn ? getColumnLabel(sortColumn) : 'None'} // Show full name on hover
        >
          <option value="" title="None">None</option>
          {columns.map(key => {
            const label = getColumnLabel(key);
            return (
              <option key={key} value={key} title={label}>
                {label}
              </option>
            );
          })}
        </select>
      </div>
      <div className="flex flex-col">
        <label className="block text-sm font-medium text-gray-700 mb-1">Order</label>
        <select 
          value={sortOrder} 
          onChange={(e) => setSortOrder(e.target.value)}
          className="w-full text-xs sm:text-sm py-1 px-1 sm:p-2 border rounded bg-white"
          style={{ 
            minWidth: '70px',
            maxWidth: '110px'  // Fixed width for order dropdown too
          }}
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
      </div>
    </div>
  );
};

export default SortingControls;